import React, { useState, useEffect } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined
import { useNavigate, useParams } from 'react-router-dom';

const EditVisit = () => {
    const [visit, setVisit] = useState({
        customer_name: '',
        contact_person_name: '',
        contact_number: '',
        description: '',
        visiting_card_image: '',
    });
    const [newImage, setNewImage] = useState(null); // For image upload
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const { id } = useParams(); // To fetch visit ID from the URL

    // Fetch visit data when the component is mounted
    useEffect(() => {
        fetch(`${BASE_URL}visits/${id}`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    setVisit(data.data);
                    setLoading(false);
                } else {
                    alert('Failed to fetch visit data');
                }
            })
            .catch(error => {
                console.error('Error fetching visit data:', error);
                alert('Error fetching visit data');
            });
    }, [id]);

    // Handle file change (visiting card image)
    const handleImageChange = (event) => {
        setNewImage(event.target.files[0]);
    };

    // Handle form submission
    const handleSubmit = async (event) => {
        event.preventDefault();

        const formData = new FormData();
        formData.append('customer_name', visit.customer_name);
        formData.append('contact_person_name', visit.contact_person_name);
        formData.append('contact_number', visit.contact_number);
        formData.append('description', visit.description);

        if (newImage) {
            formData.append('visiting_card_image', newImage);
        }

        try {
            const response = await fetch(`${BASE_URL}visits/${id}`, {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                },
                body: formData,
            });

            const data = await response.json();
            if (data.status === 1) {
                alert('Visit updated successfully!');
                navigate('/VisitsList'); // Navigate to visit list after successful update
            } else {
                alert('Failed to update visit. Please try again.');
            }
        } catch (error) {
            console.error('Error updating visit:', error);
            alert('An error occurred while updating the visit.');
        }
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Edit Visit</h3>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Edit Visit Details</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    {/* Customer Name */}
                                    <div className="mb-3">
                                        <label htmlFor="customerName" className="form-label">Firm Name</label>
                                        <input
                                            type="text"
                                            id="customerName"
                                            className="form-control"
                                            value={visit.customer_name}
                                            onChange={(e) => setVisit({ ...visit, customer_name: e.target.value })}
                                            required
                                        />
                                    </div>

                                    {/* Contact Person Name */}
                                    <div className="mb-3">
                                        <label htmlFor="contactPersonName" className="form-label">Contact Person Name</label>
                                        <input
                                            type="text"
                                            id="contactPersonName"
                                            className="form-control"
                                            value={visit.contact_person_name}
                                            onChange={(e) => setVisit({ ...visit, contact_person_name: e.target.value })}
                                            required
                                        />
                                    </div>

                                    {/* Contact Number */}
                                    <div className="mb-3">
                                        <label htmlFor="contactNumber" className="form-label">Contact Number</label>
                                        <input
                                            type="text"
                                            id="contactNumber"
                                            className="form-control"
                                            value={visit.contact_number}
                                            onChange={(e) => setVisit({ ...visit, contact_number: e.target.value })}
                                            required
                                        />
                                    </div>

                                    {/* Description */}
                                    <div className="mb-3">
                                        <label htmlFor="description" className="form-label">Description</label>
                                        <textarea
                                            id="description"
                                            className="form-control"
                                            value={visit.description}
                                            onChange={(e) => setVisit({ ...visit, description: e.target.value })}
                                            required
                                        />
                                    </div>

                                    {/* Visiting Card Image */}
                                    <div className="mb-3">
                                        <label htmlFor="visitingCardImage" className="form-label">Visiting Card Image</label>
                                        <input
                                            type="file"
                                            id="visitingCardImage"
                                            className="form-control"
                                            accept="image/*"
                                            onChange={handleImageChange}
                                        />
                                        {visit.visiting_card_image && (
                                            <div className="mt-2">
                                                <img
                                                    src={BASE_URL + visit.visiting_card_image}
                                                    alt="Current visiting card"
                                                    style={{ width: '100px', height: 'auto' }}
                                                />
                                            </div>
                                        )}
                                    </div>

                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary">Update Visit</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default EditVisit;
